// extracted by mini-css-extract-plugin
module.exports = {"privacyContainer":"TermsUpdate_privacyContainer__3QXAA","privacyList":"TermsUpdate_privacyList__22xSP"};